import FilterBar from "../../components/FilterBar";
import { TextField } from "@mui/material";
import LinksToggleSwitch from "../../components/LinksToggleSwitch";
import { UtilitiesFilter } from "./utilitiesTypes";

interface Props {
  filters: UtilitiesFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: UtilitiesFilter;
}

const UtilitiesFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={() => true}
        children={(handler: (event: any) => void) => [
          <LinksToggleSwitch startingOption="Utility Software" />,
          <TextField
            name="name"
            label="Filter By Name"
            variant="outlined"
            value={filters.name}
            onChange={handler}
          />,
        ]}
      />
    </>
  );
};

export default UtilitiesFilterBar;
